// css
import 'assets/style/elements/state-dot.scss'

/**
 * summary
 * @color {String}  - [success | error | info | warning | outline]
 */
function Element({ className, color = 'success' }) {
  return <span className={'state-dot ' + color} style={{ margin: '2px' }}></span>
}

export default Element
